/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { recursiveFindByCode } from '@src/utils/tree';
import { reportingFormsStore } from '@stores/reportingFormsStore';
import type { PagesParamInterface } from '@stores/reportingFormsStore';
import type { TreeViewInterface } from '@stores/reportingTreeStore/toViewModel';

export const useRowClick = (treeData: TreeViewInterface[]): ((props: any, data: any) => void) => {
  const { removePage, addPage, addBreadcrumbs, getReportSettings } = reportingFormsStore;

  return useCallback(
    (_, data) => {
      (async () => {
        removePage(true);

        if (data.node.reportVersionCode) {
          const nodes = recursiveFindByCode(data.node.key, treeData);

          if (nodes) {
            addBreadcrumbs(
              nodes.map((node) => node.title),
              true,
            );

            const lastNode = nodes[nodes.length - 1];

            const { reportSettings, valueParametersFromContext } = await getReportSettings(
              data.node.organizationCode,
              data.node.reportVersionCode,
              lastNode,
            );

            if (reportSettings?.url) {
              let params: PagesParamInterface = { ...valueParametersFromContext, typeForm: '' };

              params = {
                title: `${reportSettings.reportCodeExtVersion} - ${reportSettings?.reportVersionName}`,
                reportSettingsUITableSource: reportSettings.uiTableSource,
                reportFilters: [
                  [
                    {
                      name: 'report_package_code_cm',
                      type: FILTER.EQ,
                      values: [params.reportPackageCode ?? ''],
                      filterIsInverted: false,
                    },
                    {
                      name: 'report_version_code_cm',
                      type: FILTER.EQ,
                      values: [params.reportVersionCode ?? ''],
                      filterIsInverted: false,
                    },
                  ],
                ],
                ...params,
              };

              addPage(
                [
                  {
                    ...params,
                    reportVersionCode: reportSettings.reportVersionCode,
                    typeForm: reportSettings.url,
                    organizationCode: reportSettings?.organizationCode,
                  },
                ],
                true,
              );
            }
          }
        }
      })();
    },
    [removePage, treeData, addBreadcrumbs, getReportSettings, addPage],
  );
};
